import React from 'react';
import styles from './AddCoach.module.sass';
import { Link } from 'react-router-dom';
import path from '../../../config/routes.json';
import RedCross from '../../../asset/videoSeries/RedCross.webp';

const AddCoach = ({ removeSection }) => {
  return (
    <section className={styles.section}>
      <div className={styles.header_container}>
        <h1 className={styles.header}>Optional Coach Profile</h1>
        <div className={styles.description}>
          (Only For Coaches Managing a Team and Using the Program with Their Child at Home)
        </div>
      </div>
      <div className={styles.action_container}>
        <Link to={path.dashboard.createPlayerFree} className={styles.link}>
          <img className={styles.plus} src={RedCross} alt="Plus" />
          Add Coach Profile
        </Link>
        <div className={`${styles.link} ${styles.button}`} onClick={removeSection}>
          <img className={styles.cross} src={RedCross} alt="Cross" />
          Remove
        </div>
      </div>
    </section>
  );
};

export default AddCoach;
